var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFiaipMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 16,
    viewBox: "0 0 78 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4984_336)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6802 2.05012C75.6802 1.51718 76.1027 1.09468 76.638 1.09468C77.1734 1.09468 77.5959 1.51718 77.5959 2.05012C77.5959 2.58305 77.1734 3.00555 76.638 3.00555C76.1027 3.00555 75.6802 2.58305 75.6802 2.05012ZM75.8362 2.05012C75.8362 2.49903 76.2011 2.84952 76.638 2.84952C77.0749 2.84952 77.4398 2.50143 77.4398 2.05012C77.4398 1.5988 77.0749 1.25072 76.638 1.25072C76.2011 1.25072 75.8362 1.6012 75.8362 2.05012ZM76.7196 1.51958C76.914 1.51958 77.0893 1.5796 77.0893 1.80525L77.0941 1.80285C77.0941 2.01651 76.95 2.09333 76.806 2.09813L77.0773 2.59505H76.8996L76.6236 2.09813H76.4243V2.59505H76.2683V1.51958H76.7196ZM76.4243 1.94209H76.59L76.5876 1.94449C76.6053 1.94449 76.6238 1.94484 76.6427 1.9452C76.7794 1.94781 76.9332 1.95074 76.9332 1.82206C76.9332 1.68523 76.8204 1.67562 76.6908 1.67562H76.4243V1.94209Z",
    fill: "#003671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1524 0.724958H0.00390625V5.08205H18.1524V0.724958Z",
    fill: "#003671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 7.25939V11.6165V15.9712H5.81096V11.6165H18.1524V7.25939H5.81096H0.00390625Z",
    fill: "#003671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5757 7.25939V7.2906H34.0633L25.4115 15.94V7.25939H19.6045V15.9712H25.3803L25.3515 16H31.1586L35.5757 11.5853V11.6165H41.3827V15.9712H47.1922V11.6165V7.25939H41.3827H35.5757Z",
    fill: "#003671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0729 0.724959C43.0729 0.724959 40.3554 0.724959 36.2432 5.08205H47.1923C47.1923 0.232835 43.0729 0.724959 43.0729 0.724959Z",
    fill: "#003671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7484 5.79909C24.3472 5.6668 25.536 4.2635 25.4037 2.66473C25.2714 1.06596 23.8681 -0.122863 22.2693 0.0094225C20.6706 0.141708 19.4818 1.54501 19.614 3.14378C19.7463 4.74255 21.1496 5.93138 22.7484 5.79909Z",
    fill: "#003671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4516 7.25939H48.6445V15.9712H54.4516V7.25939Z",
    fill: "#003671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5473 -2.09808e-05C49.9437 -2.09808e-05 48.6426 1.3011 48.6426 2.90471C48.6426 4.50831 49.9437 5.80943 51.5473 5.80943C53.1509 5.80943 54.452 4.50831 54.452 2.90471C54.452 1.3011 53.1533 -2.09808e-05 51.5473 -2.09808e-05Z",
    fill: "#003671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9707 0.72976L55.9043 0.72736V5.08445H68.8411C69.4412 5.08445 69.9214 5.57177 69.9214 6.17432C69.9214 6.77687 69.434 7.26419 68.8315 7.26419H55.9019V15.976H61.7089V11.6213H68.9683C71.9115 11.5445 74.2761 9.13666 74.2761 6.17672C74.2761 3.21678 71.9115 0.80898 68.9683 0.734562L68.9707 0.72976Z",
    fill: "#003671"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4984_336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.6,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFiaipMobile);
export default __webpack_public_path__ + "static/media/logo-fiaip-mobile.264d4677fe49b06c778a398b9065dd0d.svg";
export { ForwardRef as ReactComponent };